class ContentHubSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.contentHubSearchResults = this.querySelector('#content_hub_search_results');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.querySelector('.icon-close').addEventListener('click', this.onFocusOut.bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {

    fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=article&resources[options][fields]=title,tag,author,body`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        
        return response.json();
      })
      .then((suggestions) => {

        const contentHubSuggestions = suggestions.resources.results.articles;
        
        if (contentHubSuggestions.length > 0) {
          let results = '';

          contentHubSuggestions.forEach(element => {
            results += '<div class="search-result"><a class="search-result-link" href="'+element.url+'">'+element.title+'</a></div>'
          });
          
          this.contentHubSearchResults.innerHTML = results;
          this.open();
        } else {
          this.contentHubSearchResults.innerHTML = '';
          this.close();
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.contentHubSearchResults.style.display = 'block';
  }

  close() {
    this.contentHubSearchResults.style.display = 'none';
  }

  onFocus() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) return;

    // if (this.getAttribute('results') === 'true') {
    //   this.open();
    // } else {
    //   this.getSearchResults(searchTerm);
    // }
    this.open();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
        if (this.classList.contains('!block')) {
          this.classList.remove('!block');
        }
      }
    })
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('content-hub-search', ContentHubSearch);

let openIcon = document.getElementById('open_search_field');
let searchField = document.getElementById('content_hub_search');

openIcon.addEventListener('click', function() {  
  searchField.classList.add('!block');

  let searchValue = document.querySelector('#content_hub_search input[type="search"]').value.trim();

  if (!searchValue.length) return;
  
  document.querySelector('#content_hub_search_results').style.display = 'block';
});  

